import setting from '@/config/setting'
/**
 * 系统埋点
 */
window.appBuryPoint = {
  setting,
  env: process.env,
}
